module.exports = __webpack_public_path__ + "img/marcoA.7f2371f9.svg";